/*
 * Project: bellcloud
 * File: packages/ui/components/common/Form.tsx
 * Description: Reusable styled form components
 */

import styled from '@emotion/styled';

export const FormStack = styled.div<{ gap?: number }>`
  display: flex;
  flex-direction: column;
  gap: ${({ theme, gap }) =>
    gap ? `${theme.spacing[gap as keyof typeof theme.spacing]}px` : `${theme.spacing[4]}px`};
`;

export const FormField = styled.div<{ direction?: 'row' | 'column' }>`
  display: flex;
  flex-direction: ${({ direction }) => direction ?? 'column'};
  gap: ${({ theme }) => `${theme.spacing[4]}px`};
  width: 100%;
  align-items: ${({ direction }) => (direction === 'row' ? 'center' : 'stretch')};
`;

export const FormLabel = styled.label`
  display: block;
  font-size: ${({ theme }) => theme.fontSize.sm};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  color: ${({ theme }) => theme.colors.text.primary};
  margin-bottom: ${({ theme }) => theme.spacing[1]}px;
`;

export const FormInput = styled.input<{ error?: boolean }>`
  width: 100%;
  padding: ${({ theme }) => `${theme.spacing[1]}px ${theme.spacing[4]}px`};
  border: 1px solid
    ${({ theme, error }) =>
      error ? theme.colors.status.danger.stroke.border : theme.colors.border.container};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  background-color: ${({ theme }) => theme.colors.surface.control.default};
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: ${({ theme }) => theme.fontSize.md}px;

  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.border.group.brand};
    box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.border.group.brand}20;
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.text.secondary};
  }

  &:disabled {
    background-color: ${({ theme }) => theme.colors.surface.control.disabled};
    color: ${({ theme }) => theme.colors.text.disabled};
    cursor: not-allowed;
  }
`;

export const FormHelperText = styled.p`
  font-size: ${({ theme }) => theme.fontSize.xs};
  color: ${({ theme }) => theme.colors.text.secondary};
  margin: ${({ theme }) => `-${theme.spacing[1]}px 0 0 0`};
`;
